export default function randomId() {
  return Math.random().toString(16).slice(-4);
}



// WEBPACK FOOTER //
// ./src/javascripts/utils/random-id.js